var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgPhone = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.68 13.75a1.562 1.562 0 0 0-1.824.445l-1.297 1.586a11.977 11.977 0 0 1-4.34-4.34l1.582-1.293c.539-.441.723-1.183.445-1.824l-1.875-4.375a1.56 1.56 0 0 0-1.762-.914l-4.375.937A1.56 1.56 0 0 0 3 5.5c0 9.031 6.844 16.469 15.63 17.402.382.04.765.07 1.156.086h.003c.239.008.473.016.711.016a1.56 1.56 0 0 0 1.528-1.234l.937-4.376a1.56 1.56 0 0 0-.914-1.761l-4.375-1.875.004-.008zm2.566 7.375C11.821 20.988 5.012 14.179 4.88 5.754l3.875-.833 1.68 3.922L9.03 9.992a1.875 1.875 0 0 0-.433 2.39 13.828 13.828 0 0 0 5.023 5.024c.797.461 1.809.277 2.391-.433l1.148-1.403 3.922 1.68-.836 3.875z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPhone, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/phone.99f1b649.svg";
export { ForwardRef as ReactComponent };